import * as d3 from 'd3'
export default function createBins(data,number_of_bins){ // It doesn't incude x0 but includes x1
    var my_min=d3.min(data)-1
    var my_max=d3.max(data)
    var bins = [];
    var binCount = 0;
    var interval = parseInt((my_max-my_min)/number_of_bins)
    //console.log(my_min,my_max,interval,d3.min(data))
    if(interval === 0){interval = 1;} //handling the cases where the count is very small
    //console.log("All bin information ",data,my_min,my_max,interval);
    //Setup Bins
    for(var i = my_min; i < my_max; i += interval){
      bins.push({x0: i, x1: i + interval, count: 0,data:[],binNum: binCount})
      binCount++;
    }
    console.log(bins,'bins')
    //Loop through data and add to bin's count
    for (var i = 0; i < data.length; i++){
      var item = data[i];
      for (var j = 0; j < bins.length; j++){
        var bin = bins[j];
        if(item > bin.x0 && item <= bin.x1){
          bin.count++;
          bin.data.push(item)
        }
      }  
    }
return bins    
}
//console.log(createBins([10, 20, 30, 40, 50],3));